import {
  BusinessArea,
  Currency,
  Language,
  MarketCountryCode,
  MeasurementSystem,
  PropertyMarketingType,
  type SearchListingsFilters,
  type SearchListingsOptions,
} from '@ev-tech/search-modules-api';

export const DEFAULT_FILTERS: SearchListingsFilters = {
  businessArea: [BusinessArea.residential],
  propertyMarketingType: [PropertyMarketingType.sale],
} as const;

export const DEFAULT_OPTIONS: Required<SearchListingsOptions> = {
  page: 1,
  pageSize: 23,
  language: Language.en,
  currency: Currency.EUR,
  measurementSystem: MeasurementSystem.metric,
  marketCountryCode: MarketCountryCode.DE,
} as const;
